import React, { memo } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { Grid, styled } from '@mui/material'
import SignInForm from '../auth/SignInForm'
import RecoverPasswordForm from '../auth/RecoverPasswordForm'
import SignIn2FAForm from '../auth/SignIn2FAForm'
import VerifyEmail from '../auth/VerifyEmail'
import SetupPassword from '../auth/SetupPassword'

const MasterGrid = styled(Grid)(({ theme }) => ({
    minHeight: '100vh',
    backgroundImage: 'url("/login-screen-background.png")',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
}))

function ExternApp() {
    return (
        <MasterGrid
            container
            justifyContent="center"
            alignItems="center"
            style={{ minHeight: '100vh' }}
        >
            <Switch>
                <Route path="/verify-email/:code" component={VerifyEmail} />
                <Route
                    path="/recover-password"
                    component={RecoverPasswordForm}
                />
                <Route
                    path="/signin/:code/password"
                    component={SetupPassword}
                />
                <Route path="/signin/:code" component={SignIn2FAForm} />
                <Route path="/signin" component={SignInForm} />
                <Redirect from="/*" to="/signin" />
            </Switch>
        </MasterGrid>
    )
}

export default memo(ExternApp)
